import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "var(--err)", fontSize: 28 }}>{t("forbidden.code")}</h1>
        <p style={{ margin: 0, fontSize: 18, color: "var(--ink)" }}>{t("forbidden.title")}</p>
        <p style={{ margin: 0, color: "var(--ink-3)", fontSize: 14 }}>
          {t("forbidden.message")}
        </p>
        <Link to="/dashboard" style={{ color: "var(--brand-ink)", fontSize: 14 }}>
          {t("forbidden.back")}
        </Link>
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "var(--surface-2)",
};
const card: React.CSSProperties = {
  background: "var(--surface)",
  padding: 32,
  borderRadius: 12,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: 12,
  boxShadow: "var(--shadow-1)",
};
